// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chassisAndChassisPoolTable {
  display: grid;
}

  .chassisAndChassisPoolTable__table {
    border: 1px solid var(--color-grayscale-5);
    width: 100%;
    text-align: left;
  }

  .chassisAndChassisPoolTable__table th {
      font-weight: 500;
      background: var(--color-grayscale-2);
    }

  .chassisAndChassisPoolTable__table th {
      padding: 15px;
      text-align: start;
    }

  .chassisAndChassisPoolTable__table td {
      text-align: start;
      transition: all 0.2s ease-in-out;
    }

  .chassisAndChassisPoolTable__table td button {
        display: block;
        width: 125px;
        text-align: start;
        padding: 15px;
      }

  .chassisAndChassisPoolTable__table td button:hover {
          cursor: pointer;
        }

  .chassisAndChassisPoolTable__table td button {
        inline-size: 135px;
        overflow-wrap: break-word;
      }

  .chassisAndChassisPoolTable__table tr {
      border: 1px solid #ccc;
    }

  .chassisAndChassisPoolTable__table tbody tr:hover {
        box-shadow: 0 9px 4px -6px grey;
      }

  .chassisAndChassisPoolTable__table tbody tr:hover td {
        border-top: 1px solid grey;
        border-bottom: 1px solid grey;
        background-color: var(--color-green-2);
      }

  .chassisAndChassisPoolTable__table tbody tr:hover td.highlight div {
        transform: scaleX(3);
      }

  .chassisAndChassisPoolTable__table .r-icon-btn {
      width: 16px;
    }

  .chassisAndChassisPoolTable__table .r-icon-btn:hover {
        cursor: pointer;
        color: var(--color-red-3);
      }

  .chassisAndChassisPoolTable__active {
    box-shadow: 0 9px 4px -6px grey;
  }

  .chassisAndChassisPoolTable__active td.highlight div {
      transform: scaleX(3);
    }

  .chassisAndChassisPoolTable__active td {
      cursor: pointer;
      background-color: var(--color-green-2);
      border-top: 1px solid grey;
      border-bottom: 1px solid grey;
    }
`, "",{"version":3,"sources":["webpack://./app/components/ChassisAndChassisPoolsTable/styles.css"],"names":[],"mappings":"AAAA;EACE,aAAa;AAkFf;;EAhFE;IACE,0CAA0C;IAC1C,WAAW;IACX,gBAAgB;EA6DlB;;EA3DE;MACE,gBAAgB;MAChB,oCAAoC;IACtC;;EAEA;MACE,aAAa;MACb,iBAAiB;IACnB;;EAEA;MACE,iBAAiB;MACjB,gCAAgC;IAiBlC;;EAfE;QACE,cAAc;QACd,YAAY;QACZ,iBAAiB;QACjB,aAAa;MAKf;;EAHE;UACE,eAAe;QACjB;;EAGF;QACE,kBAAkB;QAClB,yBAAyB;MAC3B;;EAGF;MACE,sBAAsB;IACxB;;EAGE;QACE,+BAA+B;MACjC;;EAEA;QACE,0BAA0B;QAC1B,6BAA6B;QAC7B,sCAAsC;MACxC;;EAEA;QACE,oBAAoB;MACtB;;EAGF;MACE,WAAW;IAMb;;EAJE;QACE,eAAe;QACf,yBAAyB;MAC3B;;EAIJ;IACE,+BAA+B;EAYjC;;EAVE;MACE,oBAAoB;IACtB;;EAEA;MACE,eAAe;MACf,sCAAsC;MACtC,0BAA0B;MAC1B,6BAA6B;IAC/B","sourcesContent":[".chassisAndChassisPoolTable {\n  display: grid;\n\n  &__table {\n    border: 1px solid var(--color-grayscale-5);\n    width: 100%;\n    text-align: left;\n\n    th {\n      font-weight: 500;\n      background: var(--color-grayscale-2);\n    }\n\n    th {\n      padding: 15px;\n      text-align: start;\n    }\n\n    td {\n      text-align: start;\n      transition: all 0.2s ease-in-out;\n\n      button {\n        display: block;\n        width: 125px;\n        text-align: start;\n        padding: 15px;\n\n        &:hover {\n          cursor: pointer;\n        }\n      }\n\n      button {\n        inline-size: 135px;\n        overflow-wrap: break-word;\n      }\n    }\n\n    tr {\n      border: 1px solid #ccc;\n    }\n\n    tbody {\n      tr:hover {\n        box-shadow: 0 9px 4px -6px grey;\n      }\n\n      tr:hover td {\n        border-top: 1px solid grey;\n        border-bottom: 1px solid grey;\n        background-color: var(--color-green-2);\n      }\n\n      tr:hover td.highlight div {\n        transform: scaleX(3);\n      }\n    }\n\n    .r-icon-btn {\n      width: 16px;\n\n      &:hover {\n        cursor: pointer;\n        color: var(--color-red-3);\n      }\n    }\n  }\n\n  &__active {\n    box-shadow: 0 9px 4px -6px grey;\n\n    td.highlight div {\n      transform: scaleX(3);\n    }\n\n    td {\n      cursor: pointer;\n      background-color: var(--color-green-2);\n      border-top: 1px solid grey;\n      border-bottom: 1px solid grey;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
